import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registra Service Worker per PWA (NON per pagine tessera pubbliche)
if ('serviceWorker' in navigator && !window.location.pathname.startsWith('/t/')) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ PWA Service Worker attivo');
      })
      .catch((error) => {
        console.log('⚠️ Service Worker error:', error);
      });
  });
}
